import { useNavigate } from "@tanstack/react-router";
import { ArrowRight, Sparkles } from "lucide-react";
import { useEffect, useState, type FormEvent } from "react";
import { Button, Field, Input } from "../components/ui";
import { useAuth } from "../lib/auth-context";
import styles from "./login.module.css";

export function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) void navigate({ to: "/dashboard", replace: true });
  }, [navigate, user]);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username.trim(), password);
      await navigate({ to: "/dashboard", replace: true });
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "Не удалось войти");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className={styles.page}>
      <section className={styles.intro}>
        <div className={styles.product}>
          <span>
            <Sparkles size={16} />
          </span>
          MAIA
        </div>
        <div className={styles.introCopy}>
          <p className={styles.kicker}>Klientiks Lab</p>
          <h1>Рабочая среда интеллектуальных сервисов</h1>
          <p>
            Настройка моделей, интеграций и операционных процессов в одном
            интерфейсе.
          </p>
        </div>
        <p className={styles.version}>
          {import.meta.env.VITE_DEPLOY_ENV === "development"
            ? `DEV · Тестовая среда · ${import.meta.env.VITE_RELEASE_SHA?.slice(0, 8) || ""}`
            : "Панель управления"}
        </p>
      </section>
      <section className={styles.auth}>
        <form className={styles.form} onSubmit={submit}>
          <div className={styles.formHeader}>
            <h2>Вход</h2>
            <p>Используйте свою учётную запись Klientiks Lab.</p>
          </div>
          <Field label="Логин">
            <Input
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(event) => setUsername(event.target.value)}
            />
          </Field>
          <Field label="Пароль" error={error}>
            <Input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </Field>
          <Button
            variant="primary"
            type="submit"
            loading={loading}
            disabled={!username.trim() || !password}
          >
            Продолжить <ArrowRight size={16} />
          </Button>
        </form>
      </section>
    </main>
  );
}
